'use strict';

var app = require('mag-app');

app.once('load', function () {
    app.network = core.plugins.network;
    app.api = core.plugins.audioBackend;

    require('spa-gettext').load({name: core.environment.language}, function ( error ) {
        if ( error ) {
            debug.inspect(error);
        }

        // load pages
        app.pages = {
            main: require('./pages/main')
        };

        // show main page
        // app.ready();
        app.route(app.pages.main);
    });
});
